
import { useEffect } from 'react';

/**
 * A utility component that fixes the issue with dialogs leaving pointer-events: none on body
 * This ensures proper cleanup of styles when dialog closes
 */
export const DialogFixUtil = ({ open }: { open: boolean }) => {
  useEffect(() => {
    // Reset pointer-events when dialog state changes, especially on close
    if (!open) {
      // Remove any pointer-events: none left on the body
      document.body.style.pointerEvents = '';
    }
    
    // Clean up on component unmount
    return () => {
      document.body.style.pointerEvents = '';
    };
  }, [open]);

  // This is a utility component, it doesn't render anything
  return null;
};
